module.exports = __webpack_public_path__ + "img/line.8bc9875.svg";